import type { SharedSvgProps } from '.';

import React from 'react';

import useClassy from '@core/hooks/useClassy';

import styles from './index.module.scss';

export default function RequestHistoryPreview({ style }: SharedSvgProps) {
  const bem = useClassy(styles, 'RequestHistoryPreview');

  return (
    <div
      className={bem()}
      style={{
        height: '181px',
        ...style,
      }}
    >
      <svg className={bem('-container')} fill="none" viewBox="0 0 92 131" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h92v62H0z" fill="#fff" />
        <path
          className={bem('-history')}
          d="M5.521 8.5V4.272H7.23c.909 0 1.454.507 1.454 1.313v.006c0 .56-.296 1.022-.797 1.204L8.809 8.5h-.865l-.829-1.59h-.838V8.5h-.756Zm.756-2.17h.873c.478 0 .756-.268.756-.722v-.005c0-.443-.29-.718-.77-.718h-.859v1.444ZM9.6 8.5V4.272h2.736v.636h-1.98v1.146h1.871v.6h-1.872v1.21h1.98V8.5H9.6Zm5.496.105c-1.24 0-2.001-.858-2.001-2.217v-.006c0-1.362.773-2.215 2-2.215 1.231 0 1.999.853 1.999 2.215v.006c0 .79-.261 1.415-.721 1.796l.563.755h-.739l-.342-.46c-.229.083-.481.126-.76.126Zm0-.653c.117 0 .228-.014.334-.044l-.545-.732h.738l.31.419c.25-.276.39-.692.39-1.207v-.006c0-.955-.477-1.562-1.227-1.562-.75 0-1.23.607-1.23 1.562v.006c0 .949.468 1.564 1.23 1.564Zm4.6.653c-1.07 0-1.738-.63-1.738-1.561V4.272h.756v2.71c0 .583.354.97.984.97.627 0 .979-.387.979-.97v-2.71h.756v2.772c0 .932-.663 1.561-1.738 1.561Zm2.777-.105V4.272h2.736v.636h-1.98v1.146H25.1v.6h-1.872v1.21h1.98V8.5h-2.736Zm5.141.105c-.981 0-1.605-.483-1.658-1.212l-.003-.041h.733l.003.029c.035.354.413.589.949.589.51 0 .867-.252.867-.616v-.002c0-.305-.22-.49-.765-.607l-.454-.094c-.864-.181-1.24-.586-1.24-1.215v-.003c0-.756.651-1.266 1.565-1.266.938 0 1.52.513 1.574 1.192l.003.038h-.724l-.006-.035c-.053-.328-.366-.562-.85-.56-.468 0-.802.22-.802.58v.004c0 .299.213.486.74.597l.455.097c.89.188 1.263.545 1.263 1.184v.003c0 .823-.636 1.338-1.65 1.338Zm3.551-.105V4.908h-1.3v-.636h3.36v.636H31.92V8.5h-.756Zm4.45 0V4.272h.756V6.03h2.057V4.272h.753V8.5h-.753V6.666H36.37V8.5h-.756Zm4.612 0V4.272h.755V8.5h-.755Zm3.266.105c-.981 0-1.605-.483-1.658-1.212l-.003-.041h.733l.002.029c.035.354.413.589.95.589.51 0 .867-.252.867-.616v-.002c0-.305-.22-.49-.765-.607l-.454-.094c-.864-.181-1.24-.586-1.24-1.215v-.003c0-.756.651-1.266 1.565-1.266.938 0 1.52.513 1.573 1.192l.003.038h-.723l-.006-.035c-.053-.328-.366-.562-.85-.56-.468 0-.802.22-.802.58v.004c0 .299.213.486.74.597l.455.097c.89.188 1.263.545 1.263 1.184v.003c0 .823-.636 1.338-1.65 1.338Zm3.55-.105V4.908h-1.3v-.636h3.36v.636H47.8V8.5h-.756Zm4.516.105c-1.24 0-2.001-.858-2.001-2.217v-.006c0-1.362.773-2.215 2-2.215 1.231 0 1.999.853 1.999 2.215v.006c0 1.36-.765 2.217-1.998 2.217Zm0-.653c.753 0 1.227-.615 1.227-1.564v-.006c0-.955-.477-1.562-1.227-1.562-.75 0-1.23.607-1.23 1.562v.006c0 .949.468 1.564 1.23 1.564Zm2.865.548V4.272h1.708c.908 0 1.453.507 1.453 1.313v.006c0 .56-.296 1.022-.797 1.204l.923 1.705h-.864l-.83-1.59h-.837V8.5h-.756Zm.756-2.17h.873c.477 0 .756-.268.756-.722v-.005c0-.443-.29-.718-.77-.718h-.86v1.444Zm4.362 2.17V6.833l-1.482-2.56h.826l1.008 1.813h.05l1.007-1.814h.826l-1.482 2.561V8.5h-.753Z"
          fill="#4F5A66"
        />
        <g className={bem('-history')} clipPath="url(#clip0_317_23724)">
          <g clipPath="url(#clip1_317_23724)" filter="url(#filter0_i_317_23724)">
            <path d="M5 14h82v12H5z" fill="#F8F8F8" />
            <g clipPath="url(#clip2_317_23724)">
              <rect fill="#000" fillOpacity=".1" height="4" rx="2" width="14" x="11.918" y="18" />
            </g>
            <rect fill="#000" fillOpacity=".1" height="4" rx="2" width="14" x="51.918" y="18" />
          </g>
          <g clipPath="url(#clip3_317_23724)">
            <path d="M5 26h82v12H5z" fill="#F8F8F8" />
            <rect fill="#000" fillOpacity=".1" height="4" rx="2" width="26" x="11.918" y="30" />
            <g filter="url(#filter1_dii_317_23724)">
              <g filter="url(#filter2_dii_317_23724)">
                <rect fill="#12CA93" height="5.535" rx="2.767" width="5.535" x="49.613" y="29.232" />
                <rect
                  height="5.074"
                  rx="2.537"
                  stroke="#000"
                  strokeOpacity=".15"
                  strokeWidth=".461"
                  width="5.074"
                  x="49.844"
                  y="29.463"
                />
              </g>
            </g>
            <rect fill="#000" fillOpacity=".1" height="4" rx="2" width="14" x="59.758" y="30" />
          </g>
        </g>
        <rect
          className={bem('-history')}
          height="24.461"
          rx="4.231"
          stroke="#000"
          strokeOpacity=".1"
          strokeWidth=".461"
          width="82.461"
          x="4.769"
          y="13.769"
        />
        <path
          d="M5.521 51.5v-4.227H7.21c.858 0 1.438.565 1.438 1.412v.005c0 .844-.58 1.413-1.438 1.413h-.932V51.5h-.756Zm1.503-3.61h-.747v1.603h.747c.542 0 .859-.293.859-.8v-.005c0-.507-.317-.797-.859-.797Zm1.864 3.61 1.5-4.227h.852l1.5 4.227h-.79l-.355-1.093H10.03L9.68 51.5h-.791Zm1.901-3.442-.568 1.766h1.186l-.568-1.766h-.05Zm3.26 3.442v-3.592h-1.3v-.636h3.36v.636h-1.303V51.5h-.756Zm2.851 0v-4.227h.756v1.757h2.057v-1.758h.753V51.5h-.753v-1.834h-2.057V51.5H16.9Zm6.211 0v-4.227H24.8c.858 0 1.438.565 1.438 1.412v.005c0 .844-.58 1.413-1.438 1.413h-.932V51.5h-.756Zm1.503-3.61h-.747v1.603h.747c.542 0 .859-.293.859-.8v-.005c0-.507-.317-.797-.859-.797Zm1.863 3.61 1.5-4.227h.853l1.5 4.227h-.79l-.355-1.093H27.62L27.27 51.5h-.791Zm1.902-3.442-.569 1.766h1.187l-.568-1.766h-.05Zm2.678 3.442v-4.227h1.708c.908 0 1.453.506 1.453 1.312v.006c0 .56-.296 1.022-.797 1.204l.923 1.705h-.864l-.83-1.59h-.837v1.59h-.756Zm.756-2.17h.872c.478 0 .756-.267.756-.722v-.005c0-.443-.29-.718-.77-.718h-.858v1.444Zm3.008 2.17 1.5-4.227h.853l1.5 4.227h-.791l-.355-1.093h-1.564l-.352 1.093h-.79Zm1.902-3.442-.569 1.766h1.187l-.569-1.766h-.05ZM39.4 51.5v-4.227h.868l1.271 3.251h.05l1.268-3.252h.868V51.5h-.68v-3.006h-.053L41.82 51.5h-.515l-1.172-3.006h-.05V51.5H39.4Zm6.835.105c-.981 0-1.605-.483-1.658-1.212l-.003-.041h.733l.003.029c.035.354.413.589.949.589.51 0 .867-.252.867-.615v-.003c0-.305-.22-.49-.765-.607l-.454-.094c-.864-.181-1.239-.586-1.239-1.216v-.002c0-.756.65-1.266 1.564-1.266.938 0 1.52.513 1.574 1.192l.003.038h-.724l-.006-.035c-.053-.328-.366-.562-.85-.56-.468 0-.802.22-.802.58v.004c0 .299.214.486.741.597l.454.097c.89.188 1.263.545 1.263 1.184v.003c0 .823-.636 1.338-1.65 1.338Z"
          fill="#4F5A66"
        />
        <g clipPath="url(#clip4_317_23724)">
          <g filter="url(#filter3_i_317_23724)">
            <path d="M5 57h82v24H5z" fill="#F8F8F8" />
            <rect fill="#000" fillOpacity=".1" height="6" rx="2.628" width="25" x="10" y="62" />
            <rect fill="#000" fillOpacity=".1" height="4" rx="2" width="35" x="10" y="72" />
            <rect fill="#fff" height="13.837" rx="2.306" width="30" x="52" y="62.081" />
            <rect
              height="14.299"
              rx="2.537"
              stroke="#000"
              strokeOpacity=".1"
              strokeWidth=".461"
              width="30.461"
              x="51.769"
              y="61.85"
            />
          </g>
          <path d="M5 81h82v24H5z" fill="#F8F8F8" />
          <rect fill="#000" fillOpacity=".1" height="6" rx="2.628" width="28" x="10" y="86" />
          <rect fill="#000" fillOpacity=".1" height="4" rx="2" width="35" x="10" y="96" />
          <rect fill="#fff" height="13.837" rx="2.306" width="30" x="52" y="86" />
          <rect
            height="14.299"
            rx="2.537"
            stroke="#000"
            strokeOpacity=".1"
            strokeWidth=".461"
            width="30.461"
            x="51.769"
            y="85.769"
          />
        </g>
        <rect
          height="48.461"
          rx="4.231"
          stroke="#000"
          strokeOpacity=".1"
          strokeWidth=".461"
          width="82.461"
          x="4.769"
          y="56.769"
        />
        <defs>
          <clipPath id="clip0_317_23724">
            <rect fill="#fff" height="24" rx="4" width="82" x="5" y="14" />
          </clipPath>
          <clipPath id="clip1_317_23724">
            <path d="M5 14h82v12H5z" fill="#fff" />
          </clipPath>
          <clipPath id="clip2_317_23724">
            <path d="M5 14h40v12H5z" fill="#fff" />
          </clipPath>
          <clipPath id="clip3_317_23724">
            <path d="M5 26h82v12H5z" fill="#fff" />
          </clipPath>
          <clipPath id="clip4_317_23724">
            <rect fill="#fff" height="48" rx="4" width="82" x="5" y="57" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}
